<template>
  <WhiteIQOS :subtitle="$t('menu_settings.show_exclusives_desc')" :useShadow="menu.show_exclusives" :enabled="false" :title="$t('menu_settings.show_exclusives')">
    <template #actions>
      <IQOSToggle :value="menu.show_exclusives" @input="setValue" />
    </template>
  </WhiteIQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import RoundCheckbox from "@/components/RoundCheckbox.vue";
import IQOSToggle from "@/components/IQOSToggle.vue";

export default {
  components: {
    IQOS,
    RoundCheckbox,
    IQOSToggle,
  },
  methods: {
    setValue(v) {
      this.$store.commit("menu/setMenuShowExclusives", {
        menu_id: this.menu._id,
        value: v,
      });

      this.$store.dispatch("menu/save");
    },
  },
  computed: {
    menu() {
      return this.$store.state.menu.current;
    },
  },
};
</script>

<style>
</style>